import initializePickers from '../plugins/PluginPicker'

window.addEventListener('load', () => {
  initializePickers({
    activeIndexes: [],
    noSelected: true,
    activeClass: 'show',
    pickerSelector: '[data-picker="settings"]',
    multiplePickerSelector: '',
    buttonSelector: '[data-picker-btn]',
    itemSelector: '[data-picker-item]',
  })
})
